import bootbox from 'bootbox';
import Util from '../utils/util.js';
import { webformIsDisabled } from '../utils/webform.js';
import { preserveUnsavedState } from '../utils/beforeunload.js';

if (window.site_type && window.site_type === 'ftf') {

/**********************************************************
 *                 Researchers module
 */
function onReadyResearchers() {}

/**********************************************************
 *                 Researchers subform
 */
function onReadyResearchersSubform() {
    if (webformIsDisabled()) {
        $('#search_researchers').remove();
        return;
    }

    // Handle search
    let id = $('.webform input[name="id"]').val();
    if (id) {
        $('#search-section').removeClass('in');
    } else {
        $('#search-section').addClass('in');
    }

    $('#search_researchers').typeahead({}, {
        name: 'search_researchers',
        displayKey: 'name',
        source: function(query, sync, async) {
            $.ajax(window['public_path'] + '/researchers/search/' + query, {dataType: 'json'})
                .success(function(result) {
                    async(result);
                });
        },
        templates: {
            suggestion: function (t) {
                return '<div><div class="name">'+(t.name||'')+'</div><div class="email">'+(t.email||'')+'</div></div>';
            }
        }
    }).on('typeahead:select typeahead:autocomplete', function($e, datum) {
        Util.setFromJson(datum);
    });
}
/**********************************************************
 *                 Publications module
 */
function publicationArrangeFields(type)
{
    if (type == 'book_chapter') {
        $('#first_page_or_elocation_id').parents('.form-group').insertBefore($('#book_edition').parents('.form-group'));
    } else {
        $('#first_page_or_elocation_id').parents('.form-group').insertBefore($('#publication_date').parents('.form-group'));
    }
    if ($.inArray(type,['conference_paper_or_proceeding','presentation','other']) !== -1) {
        $('#publication_date').parents('.form-group').insertBefore($('#status').parents('.form-group'));
    } else {
        $('#publication_date').parents('.form-group').insertBefore($('#publication_location').parents('.form-group'));
    }
}

function publicationModifyFields(type)
{
    // Set title (field #2)
    switch (type) {
        case "journal":
            $("label[for='title']").text('Article Title');
            break;
        case "book":
        case "book_chapter":
            $("label[for='title']").text('Book Title');
            break;
        case "conference_paper_or_proceeding":
        case "presentation":
            $("label[for='title']").text('Paper or Presentation Title');
            break;
        case "other":
            $("label[for='title']").text('Publication Title');
            $('.webform_element_other_description .help-block').text('A description of the nature of the publication.').show();
            break;
        case "training":
            $('.webform_element_other_description .help-block').text('A description of the nature of the publication.').show();
            break;
        case "flyer":
            $('.webform_element_title .help-block').show();
            $('.webform_element_other_description .help-block').text('Please describe the nature of the publication.').show();
            break;
        default:
            $("label[for='title']").text('Title');
            $('.webform_element_title .help-block').hide();
            break;
    }

    // Set authors (field #4)
    switch (type) {
        case "journal":
            $("label[for='contactlist']").text('Article Author(s)');
            break;
        case "book_chapter":
            $("label[for='contactlist']").text('Chapter Author(s)');
            break;
        default:
            $("label[for='contactlist']").text('Author(s)');
            break;
    }

    // Set volume (field #13)
    switch (type) {
        case "journal":
            $("label[for='volume']").text('Journal Volume');
            break;
        case "book":
        case "book_chapter":
            $("label[for='volume']").text('Book Volume');
            $(".webform_element_volume .help-block").text('The book volume number, if applicable.').show();
            break;
        default:
            $("label[for='volume']").text('Volume');
            $(".webform_element_volume .help-block").hide();
            break;
    }

    // Set publication_date (field #16) and publication_location (field #18)
    switch (type) {
        case "conference_paper_or_proceeding":
        case "presentation":
            $("label[for='title']").text('Title');
            $("label[for='publication_date']").text('Presentation Date');
            $("label[for='publication_location']").text('Conference Location');
            $(".webform_element_publication_location .help-block").text('The city and country where the conference was held.');
            $(".webform_element_publication_link .help-block").text('Optional. If the publication or presentation is posted online somewhere else, please link it here.');
            $(".webform_element_files .help-block").text('Please upload your publication or presentation as a PDF file, if available.');
            $(".webform_element_publication_date, .webform_element_publication_location").removeClass('show_if_published').show(); // Force to show in case was hidden before by show_if_published
            break;
        case 'policy_brief':
        case 'technical_brief':
        case 'non_peer_reviewed':
        case 'video':
        case 'poster':
        case 'flyer':
        case 'training':
        case 'radio':
        case 'website':
            $("label[for='title']").text('Title');
            break;
        case 'workshop':
            $("label[for='title']").text('Event Name');
            break;
        case 'outreach_engagement':
            $("label[for='publication_date']").text('Date');
            $("label[for='publication_location']").text('Location');
            $(".webform_element_publication_location .help-block").text('City and country of outreach/engagement event.');
            $(".webform_element_publication_link .help-block").text('Optional. Provide a link about the event, e.g. workshop information shared online.');
            $(".webform_element_files .help-block").text('Please upload documentation of the outreach/engagement (e.g., report, program)  as a PDF file, if available.');
            $(".webform_element_publication_date, .webform_element_publication_location").removeClass('show_if_published').show();
            break;
        case 'scientific_lectures':
            $(".webform_element_other_description .help-block").text('A description of the nature of the Lecture/Seminar.');
        case 'social_media':
        case 'working_papers':
            $("label[for='type_other']").text('Type of post');
            $("label[for='publication_date']").text('Publication Date');
            $(".webform_element_publication_date, .webform_element_publication_location").removeClass('show_if_published').show(); // Force to show in case was hidden before by show_if_published
            break;
        case 'working_papers_other_reports':
            $("label[for='type_other']").text('Type of post');
            $("label[for='publication_date']").text('Publication Date');
            $(".webform_element_publication_date, .webform_element_publication_location").removeClass('show_if_published').show(); // Force to show in case was hidden before by show_if_published
            break;
        case 'other':
            $("label[for='type_other']").text('Please specify');
            break;
        default:
            $("label[for='publication_date']").text('Publication Date');
            $("label[for='publication_location']").text('Publication Location');
            $(".webform_element_publication_location .help-block").text('The city and country of publication.');
            $(".webform_element_publication_link .help-block").text('Optional. If the publication or presentation is posted online somewhere else, please link it here.');
            $(".webform_element_files .help-block").text('Please upload your publication or presentation as a PDF file, if available.');
            $(".webform_element_other_description .help-block").text('A description of the nature of the publication/presentation.');
            $(".webform_element_publication_date, .webform_element_publication_location").addClass('show_if_published');
            break;
    }

    // Show dropzone
    switch (type) {
        case "conference_paper_or_proceeding":
        case "presentation":
        case "journal_article":
            $('.show_files_if_published #dropzone_files').addClass('show_if_published');
            break;
        default:
            $('.show_files_if_published #dropzone_files').removeClass('show_if_published');
            break;
    }

}

/**********************************************************
 *                 Publications module
 */
function onReadyPublications() {
    let jType = $('#type');
    jType.change(function() {
        publicationArrangeFields(Util.makeBareSlug(jType.val()));
        publicationModifyFields(Util.makeBareSlug(jType.val()));
        Util.setupLabelPositionAdjuster();
    });
    jType.change();
    let jWebform = $('.webform');
    $('.show_files_if_published .mimic-table').addClass('show_if_published');
    $('.show_if_accepted, .show_if_awaiting, .show_if_published', jWebform).css('display', 'none');
    $('#status').change(function() {
        jWebform
            .addClass('not_published')
            .removeClass('published')
            .removeClass('awaiting')
            .removeClass('accepted');
        switch (Util.makeBareSlug($('#status').val())) {
            case 'published': // published
                jWebform
                    .addClass('published')
                    .removeClass('not_published');
                break;
            case 'awaiting_publication': // awaiting
                jWebform.addClass('awaiting');
                break;
            case 'accepted': // accepted
                jWebform.addClass('accepted');
                break;
        }
    });
    $('#status').change();

    $('#peer_reviewed').change(function() {
        switch ($('#peer_reviewed').val()) {
            case "1": // disclosure
                $('.webform').removeClass('not_peer_reviewed');
                break;
            default:
                $('.webform').addClass('not_peer_reviewed');
                break;
        }
    }).change();

    // Assign completion handles to the designated fields.
    Util.assignCompletion(['title', 'chapter_title'], 'publications')
}

/**********************************************************
 *                 TechnologyTransfer module
 */
function onReadyTechnologyTransfer() {
    $("#status\\[technology_transfer_status----phase_1_research\\]").parent('label').append("&nbsp;<a href='#' data-toggle='modal' data-target='#phase1Modal'>(Click here for details)</a>")
    $("#status\\[technology_transfer_status----phase_2_field_testing\\]").parent('label').append("&nbsp;<a href='#' data-toggle='modal' data-target='#phase2Modal'>(Click here for details)</a>")
    $("#status\\[technology_transfer_status----phase_3_transfer\\]").parent('label').append("&nbsp;<a href='#' data-toggle='modal' data-target='#phase3Modal'>(Click here for details)</a>")
    $("#status\\[technology_transfer_status----phase_4_uptake\\]").parent('label').append("&nbsp;<a href='#' data-toggle='modal' data-target='#phase4Modal'>(Click here for details)</a>")
    $("#status_multi\\[technology_transfer_status----phase_1_research\\]").parent('label').append("&nbsp;<a href='#' data-toggle='modal' data-target='#phase1Modal'>(Click here for details)</a>")
    $("#status_multi\\[technology_transfer_status----phase_2_field_testing\\]").parent('label').append("&nbsp;<a href='#' data-toggle='modal' data-target='#phase2Modal'>(Click here for details)</a>")
    $("#status_multi\\[technology_transfer_status----phase_3_transfer\\]").parent('label').append("&nbsp;<a href='#' data-toggle='modal' data-target='#phase3Modal'>(Click here for details)</a>")
    $("#status_multi\\[technology_transfer_status----phase_4_uptake\\]").parent('label').append("&nbsp;<a href='#' data-toggle='modal' data-target='#phase4Modal'>(Click here for details)</a>")
}

/**********************************************************
 *                 Equipment module
 */
function onReadyModuleEquipment() {
    if (!$('#staff_response').val()) {
        $('#staff_response_section').remove();
    } else {
        $('#staff_response').replaceWith('<div class="alert alert-info fake-textarea">' + $('#staff_response').html() + '</div>');
    }
    $('#new_staff_response_section').remove();
    equipment_set_waiver();
    addCancelRequestButton();
}

function equipment_set_waiver() {
    let j_vendor_country = $('#vendor_country');
    $('#waiver_needed').prop('disabled', true);
    $('#waiver_needed').after('<input name="waiver_needed" id="waiver_needed_hidden" type="hidden"><div id="waiver_needed_message"></div>')
    j_vendor_country.change(equipment_country_change); // set change fn
    $('#manufacturer_country, #type').change(equipment_country_change); // set change fn
    j_vendor_country.change(); // call change fn
}

function equipment_country_change() {
    let isVehicle = Util.makeBareSlug($('#type').val()) == 'vehicle';
    let vendorCountryVal = Util.makeBareSlug($('#vendor_country').val());
    let manufacturerCountryVal = Util.makeBareSlug($('#manufacturer_country').val());
    if (manufacturerCountryVal && (
            vendorCountryVal == 'other' ||
            (isVehicle && manufacturerCountryVal != 'usa') ||
            ( ! isVehicle && manufacturerCountryVal == 'other')
        )
    ) {
        $('#waiver_needed').val('Yes').change();
        $('#waiver_needed_hidden').val('Yes');
        let msg = 'A waiver is required because because "Other" is selected for either the vendor or manufacturer country.';
        if (isVehicle && manufacturerCountryVal != 'usa') {
            msg = 'A waiver is required because the vehicle is not manufactured in the USA.';
        }
        set_equipment_message(msg);
    } else {
        $('#waiver_needed').val('No').change();
        $('#waiver_needed_hidden').val('No');
        set_equipment_message('A waiver is not required because the selected vendor and manufacturer countries do not require one.');
    }
}

function set_equipment_message(msg) {
    $('#waiver_needed_message').replaceWith('<div style="margin-bottom:0" id="waiver_needed_message" class="alert alert-info"><p>' + msg +
        '</p><p>Equipment requires a source and/or origin waiver if the source (vendor) and/or origin (manufacturer) are other than ' +
        'U.S., other than a developing country where the work is taking place, or a country that is a direct recipient of the aid.</p></div>');
}

/**********************************************************
 *                 Equipment Approvals module
 */
function onReadyModuleApprovalEquipment() {
    replace_staff_response_with_fake_textarea();
    $('.webform textarea').not('#new_staff_response').each(function() {
        $(this).replaceWith('<div class="panel panel-default fake-textarea disabled"><div class="panel-body">' + $(this).html() + '</div></div>');
    });
}

function addCancelRequestButton() {
    let jPlaceName = $('#place_name');
    if (jPlaceName.val()) {
        // Add cancel request button (note that the red "X" uses the "cancel" action, so we use "cancel_request"
        let id = $('#webform_id_field').val();
        let cancelBtn =
            '<input class="btn-danger btn webform-cancel-request confirm" data-confirm="Really cancel this request?" ' +
            'name="_webform_action[cancel_request][' + id + ']" type="submit" value="Cancel Request">'
        if (webformIsDisabled()) {
            if (jPlaceName.val() !== 'Cancelled') {
                $('form.webform').append(cancelBtn);
            }
        } else {
            $('.webform-delete').replaceWith(cancelBtn);
        }
    }
}

/**********************************************************
 *                 Travel module
 */
function onReadyModuleTravel() {
    replace_staff_response_with_fake_textarea();
    addCancelRequestButton();
    // If depart date changes, set return date to + 1 day unless it's already set to a future date
    $('#depart_date').change(function() {
        let departDate = new Date($('#depart_date').val());
        let returnDate = new Date($('#return_date').val());
        if ( ! $('#return_date').val() || departDate >= returnDate) {
            let newDate = new Date(departDate);
            newDate.setDate(departDate.getDate() + 1);
            $('#return_date').pikaday('setDate', newDate);
        }
    });

    $('#travel_type').change(function () {
        if ($('#travel_type').val() === 'travel_type----domestic') {
            $('.hide_if_domestic').hide();
        }
        else {
            $('.hide_if_domestic').show();
        }
    });
}

function replace_staff_response_with_fake_textarea() {
    if (!$('#staff_response').val()) {
        $('#staff_response_section').remove();
    } else {
        $('#staff_response').replaceWith('<div class="alert alert-info fake-textarea">' + $('#staff_response').html() + '</div>');
    }
}

/**********************************************************
 *                 Travel Approvals module
 */
function onReadyModuleApprovalTravel() {
    replace_staff_response_with_fake_textarea();
    if (!$('#additional_info').val()) {
        $('#additional_info').html('N/A');
    }
    $('.webform textarea').not('#new_staff_response').each(function() {
        $(this).replaceWith('<div class="panel panel-default fake-textarea disabled"><div class="panel-body">' + $(this).html() + '</div></div>');
    });
}

/**********************************************************
 *                 Data Management module
 */
function onReadyModuleDataManagement()
{
    if (typeof dataManagementListView != 'undefined') { // Don't run this code on add/edit view
        dataManagementListView();
    }
}

/**********************************************************
 *                 Short Training Module
 */
function onReadyModuleShortTraining()
{
    $('#trainet_required').change(function() {
        if ($('#trainet_required').val() === '1') {
            $('.show_if_trainet').show();
        }
        else {
            $('.show_if_trainet').hide();
        }
    });
    $('#trainet_required').change();
}

/**********************************************************
 *                 Piestar Request module
 */
function onReadyPiestarRequest() {
    let jType = $('#request_type');
    jType.change(function() {
        piestarRequestModifyFields(Util.makeBareSlug(jType.val()));
    });
}

function piestarRequestModifyFields(type) {
    switch (type) {
        case "innovation_lab":
        case "sub_project":
            $('.webform_element_name .help-block').text('Official name of Innovation Lab/Implementing Partner').show();
            break;
        case "country":
            $('.webform_element_name .help-block').text('Name of country').show();
            break;
        default:
            $('.webform_element_name .help-block').text('Official name of Innovation Lab/Implementing Partner').show();
            break;
    }
}

/**********************************************************
 *                 EMMP Module
 */
function onReadyModuleEmmp()
{
    $('#activity').change(function() {
        if ($('#activity').val() === 'emmp_activity----less_than_4_ha') {
            $('.show_if_less').show();
            $('.show_if_more').hide();
            $('.show_if_categorical_exclusion').show();
            $('.webform_element_resources').show();
            $('.webform_element_mitigation').show();
            $('.webform_element_monitoring').show();
            $('.webform_element_timing').show();
            $('.webform_element_responsibility').show();
        }
        else if($('#activity').val() === 'emmp_activity----more_than_4_ha') {
            $('.show_if_more').show();
            $('.show_if_less').hide();
            $('.show_if_categorical_exclusion').show();
            $('.webform_element_resources').show();
            $('.webform_element_mitigation').show();
            $('.webform_element_monitoring').show();
            $('.webform_element_timing').show();
            $('.webform_element_responsibility').show();
        }
        else if ($('#activity').val()) {
            $('.show_if_categorical_exclusion').show();
            $('.show_if_more').hide();
            $('.show_if_less').hide();
            $('.webform_element_resources').hide();
            $('.webform_element_mitigation').hide();
            $('.webform_element_monitoring').hide();
            $('.webform_element_timing').hide();
            $('.webform_element_responsibility').hide();
        }
        else {
            $('.show_if_more').hide();
            $('.show_if_less').hide();
            $('.show_if_categorical_exclusion').hide();
        }
    });
    $('#activity').change();
}

function setupModule(module_slug, is_subform) {
    if (module_slug == 'researchers') {
        onReadyResearchers();
        if (is_subform) {
            onReadyResearchersSubform();
        }
    }
    if (module_slug == 'publications') { onReadyPublications() }
    if (module_slug == 'technology_transfer') { onReadyTechnologyTransfer() }
    if (module_slug == 'equipment') { onReadyModuleEquipment() }
    if (module_slug == 'travel') { onReadyModuleTravel() }
    if (module_slug == 'supplies') { onReadyModuleSupplies() }
    if (module_slug == 'data_management') { onReadyModuleDataManagement() }
    if (module_slug == 'short_training') { onReadyModuleShortTraining() }
    if (module_slug == 'emmp') { onReadyModuleEmmp() }
    if (module_slug == 'piestar_request') { onReadyPiestarRequest() }
    if (window['route'] == 'manage.requests.travel.edit') { onReadyModuleApprovalTravel() }
    if (window['route'] == 'manage.requests.equipment.edit') { onReadyModuleApprovalEquipment() }

    $('.webform .webform_element_type_checkboxes:not(.single) > label').append('<br><span class="apply">(select all that apply)</span>');
    Util.setupLabelPositionAdjuster(); // Must be after module loaders, as they may change label contents

    let reentrant = false;
    $('#_webform_action\\[request_approval\\], #_webform_action\\[submit_report\\]').click(function() {
        if (reentrant) return true;
        let submitText = "Are you sure you want to submit this? Once submitted you will no longer be able to make changes.";
        if (module_slug === 'e_signature') {
            submitText = "Are you sure? When you press \"OK\", all Signers will receive an email requesting an E-signature. This action cannot be undone."
        }
        let theForm = $('form.webform');
        bootbox.confirm(submitText, function(result) {
            if (result) {
                reentrant = true;
                window.form_changed = false; // prevent browser warning popup
                $('#_webform_action\\[request_approval\\]').click();
            }
        });
        return false; // prevent default
    });
}

/**********************************************************
 *                 Supplies module
 */
function supplyModifyFields(type)
{
    // Set title (field #2)
    switch (type) {
        case "fertilizer":
            $("label[for='product']").text('Product');
            $('.webform_element_product .help-block').text(
                'Please specify the commodity or other product proposed to be purchased. Example: maize, wheat, name of pesticide or fertilizer');
            $('.webform_element_total_cost .help-block').text(
                'Please state the total cost of the proposed purchase. As requests should be made on an annual basis, this cost estimate should include one year of activities.');
            $("#persuap_help").text('I acknowledge that I am responsible for developing and ' +
                'monitoring fertilizer use protocols that safeguard the health of research personnel and protect local ' +
                'ecosystems. This includes fertilizer storage, handling and application, use of personal protective ' +
                'equipment (PPE), clean-up, and disposal.');
            break;
        case "seed":
            $("label[for='product']").text('Crop');
            $('.webform_element_product .help-block').text(
                'Please specify the crop (bean, cowpea, etc.) of seed proposed to be purchased.');
            $('.webform_element_total_cost .help-block').text(
                'Please state the total cost of the proposed seed purchase.');
            $('#persuap_help').text(
                'I acknowledge that once the seed is purchased and pursuant to ADS 312mac, that I am responsible for submitting,' +
                'either a Seed Certification Label officially recognized by the country where the seed was grown or a ' +
                'Seed Grower\'s Declaration of Quality.  The Declaration of Quality must, where possible, be based on ' +
                'sampling and testing by a recognized seed laboratory, and must state as much of the following information ' +
                'as applicable and possible: (1) Crop and variety; (2) Where the seed was grown (country); (3) Seed lot ' +
                'number; (4) Incidence of weed seeds; (5) Percentage of inert matter;  (6) Germination and hard seed;  ' +
                '(7) Names and rates of noxious weed-seed occurrence (which must conform to laws of the country where ' +
                'the seeds are to be used).  (8) Month/year in which purity and germination tests were completed; (9) If ' +
                'seed was treated, chemicals with which treated and cautionary statement if advisable. (10) Where, and by ' +
                'whom the seed was tested, i.e., laboratory, etc.  The Seed Grower\'s Declaration of Quality must identify ' +
                'the Supplier\'s transaction by date and quantity, and identify the lot involved. The Declaration must be ' +
                'dated and signed by an individual authorized to bind the grower and shall be issued to the Supplier.');
            break;
        default:
            $("label[for='product']").text('Product');
            $('.webform_element_product .help-block').text(
                'Please specify the commodity or other product proposed to be purchased. Example: maize, wheat, name of pesticide or fertilizer');
            $('.webform_element_total_cost .help-block').text(
                'Please state the total cost of the proposed purchase. As requests should be made on an annual basis, this cost estimate should include one year of activities.');
            $('#persuap_help').text(
                'I acknowledge that I am responsible for developing and monitoring pesticide use protocols that are aligned ' +
                'with the relevant country\'s PERSUAP to safeguard the health of research personnel and to protect local ' +
                'ecosystems that are developed and implemented, based on toxicological and environmental data for the proposed ' +
                'pesticide(s). This includes pesticide storage, handling and application, including the use of personal ' +
                'protective equipment (PPE), clean-up, and disposal.');
            break;
    }
}

function onReadyModuleSupplies() {
    // Peanutlab wants a more straight forward form
    if (window.site === 'peanutlab') {
        return
    }
    let jType = $('#type');
    jType.change(function() {
        supplyModifyFields(Util.makeBareSlug(jType.val()));
    });
    jType.change();

    let jWebform = $('.webform');
    $('.show_if_foreign', jWebform).css('display', 'none');
    $('#vendor_country').change(function() {
        jWebform
            .addClass('not_foreign')
            .removeClass('foreign');
        switch (Util.makeBareSlug($('#vendor_country').val())) {
            case 'USA':
                break;
            default:
                jWebform
                    .addClass('foreign')
                    .removeClass('not_foreign');
        }
    });
    $('#vendor_country').change();
    supplies_set_waiver();
}

    function supplies_set_waiver() {
        let j_vendor_country = $('#vendor_country');
        $('#waiver_needed').prop('disabled', true);
        $('#waiver_needed').after('<input name="waiver_needed" id="waiver_needed_hidden" type="hidden"><div id="waiver_needed_message"></div>')
        j_vendor_country.change(supplies_country_change); // set change fn
        j_vendor_country.change(); // call change fn
    }

    function supplies_country_change() {
        let vendorCountryVal = Util.makeBareSlug($('#vendor_country').val());
        console.log(vendorCountryVal);
        if (vendorCountryVal != 'USA')
        {
            $('#waiver_needed').val('Yes').change();
            $('#waiver_needed_hidden').val('Yes');
            set_supplies_message('A waiver is required because the vendor is not in the USA.');
        } else {
            $('#waiver_needed').val('No').change();
            $('#waiver_needed_hidden').val('No');
            set_supplies_message('A waiver is not required because the selected vendor countries do not require one.');
        }
    }

    function set_supplies_message(msg) {
        $('#waiver_needed_message').replaceWith('<div style="margin-bottom:0" id="waiver_needed_message" class="alert alert-info"><p>' + msg + '</div>');
    }

/**********************************************************
 *                 OnReady handler
 */
$(document).ready(function() {
    if (typeof window['route_module_slug'] !== 'undefined') {
        let module_slug = window['route_module_slug'];
        let is_subform = module_slug == window['route_subform_element'];
        preserveUnsavedState(() => setupModule(module_slug, is_subform));
    }
});

}
